import { render, staticRenderFns } from "./no-items-call-to-action.vue?vue&type=template&id=14dad853&scoped=true&"
import script from "./no-items-call-to-action.vue?vue&type=script&lang=js&"
export * from "./no-items-call-to-action.vue?vue&type=script&lang=js&"
import style0 from "./no-items-call-to-action.vue?vue&type=style&index=0&id=14dad853&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dad853",
  null
  
)

export default component.exports